import { render } from "./acceptanceSummary.vue?vue&type=template&id=64ed94de"
import script from "./acceptanceSummary.vue?vue&type=script&lang=js"
export * from "./acceptanceSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__